import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import DataTable from 'react-data-table-component';
import red from 'sushiweb/tokens/color/red';
import Spinner from 'sushiweb/Spinner/Spinner';
import { customTableStyle } from './constants';
import { SpinnerHolder } from '../../styles';
import EmptyData from './components/Empty';

const DataTables = ({
  loading,
  columns,
  data,
  pagination,
  paginationNumber,
  totalRows,
  handlePageChange,
  onSort,
  emptyStateTitle,
}) => {
  return data.length === 0 && !loading ? (
    <EmptyData emptyStateTitle={emptyStateTitle} />
  ) : (
    <DataTable
      progressPending={loading}
      progressComponent={
        <SpinnerHolder className='center'>
          <Spinner color={red.z_red} size='medium' />
        </SpinnerHolder>
      }
      pagination={pagination}
      paginationServer={pagination}
      paginationTotalRows={totalRows}
      columns={columns}
      data={data}
      customStyles={customTableStyle}
      onChangePage={handlePageChange}
      paginationPerPage={paginationNumber}
      onSort={onSort}
    />
  );
};

DataTables.propTypes = {
  loading: PropTypes.bool,
  pagination: PropTypes.bool,
  paginationNumber: PropTypes.number,
  totalRows: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.objectOf),
  columns: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  handlePageChange: PropTypes.func,
  onSort: PropTypes.func,
  emptyStateTitle: PropTypes.string,
};

DataTables.defaultProps = {
  loading: true,
  pagination: false,
  paginationNumber: 10,
  data: [],
  handlePageChange: _noop,
  onSort: _noop,
  emptyStateTitle: '',
};

export default DataTables;
